module.exports = __webpack_public_path__ + "img/feature_02.cfbf01b1.jpg";